import { RootState } from "../../../../store";
import { resourceExplorerStateSelector } from "../../resourceExplorerStateSelector";

export const resourceExplorerChartTypeSelector = (state: RootState) => {
  return resourceExplorerStateSelector(state).chartType;
};
